/**
 * validatePackageNumber function
 *
 * @param {string} packageNumber
 * @returns {Boolean}
 */
export default function validatePackageNumber(packageNumber: string) {
    // When regexes haven't loaded yet (e.g. fresh environment, API not ready),
    // allow the number through so the online validation can decide.
    if (!this.packageRegexes || this.packageRegexes.length === 0) {
        return true;
    }

    for (const regex of this.packageRegexes) {
        const regexToTest = new RegExp(regex);
        if (regexToTest.test(packageNumber)) {
            return true; // Exit immediately if a match is found
        }
    }

    return false; // No match found
}
